import { render } from "./Ineligible.vue?vue&type=template&id=ea095b44&scoped=true"
import script from "./Ineligible.vue?vue&type=script&lang=js"
export * from "./Ineligible.vue?vue&type=script&lang=js"

import "./Ineligible.vue?vue&type=style&index=0&id=ea095b44&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea095b44"]])

export default __exports__